module.exports = __webpack_public_path__ + "static/media/4adva.b41f9d8a.png";